// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track WhatsApp clicks
export const trackWhatsAppClick = (source) => {
  trackEvent('whatsapp_click', {
    event_category: 'Contact',
    event_label: source,
    value: 1
  });
};

// Track booking button clicks
export const trackBookingClick = (source) => {
  trackEvent('booking_click', {
    event_category: 'Conversion',
    event_label: source,
    value: 1
  });
};

// Track phone clicks
export const trackPhoneClick = (source) => {
  trackEvent('phone_click', {
    event_category: 'Contact',
    event_label: source,
    value: 1
  });
};

// Track navigation
export const trackNavigation = (destination) => {
  trackEvent('navigation', {
    event_category: 'Navigation',
    event_label: destination,
    value: 1
  });
};

// Track image gallery interactions
export const trackImageView = (imageName) => {
  trackEvent('image_view', {
    event_category: 'Engagement',
    event_label: imageName,
    value: 1
  });
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  trackEvent('scroll_depth', {
    event_category: 'Engagement',
    event_label: `${depth}%`,
    value: depth
  });
};

// Track contact widget interactions
export const trackContactWidget = (action) => {
  trackEvent('contact_widget', {
    event_category: 'Engagement',
    event_label: action,
    value: 1
  });
};
